export const siteSettings = {
  name: "Nadex Global Market",
  link: "https://nadexmarket.net",
  email: "support@nadexmarket.net",
  appLink: "https://app.nadexmarket.net",
};
